var exports = {
  "m": "LoadableComponent.module__inline___eDhiZV",
  "p": "LoadableComponent.module__inlineIcon___eDhiZV",
};

module.exports = exports;
